// Configuration
const IMAGE_SIZES = [50, 400, 800, 1280];
const OPTIMIZED_FORMAT = 'avif';

export const isOptimizableUrl = (url) => {
  if (!url || typeof url !== 'string') return false;

  // Omitir imágenes locales
  const localPatterns = [/^\/images\//, /^\.\/images\//, /^\.\.\/images\//, /^\/assets\//, /^blob:/, /^data:image\//];

  if (localPatterns.some((pattern) => pattern.test(url))) {
    return false;
  }

  // Solo URLs absolutas (S3)
  return /^https?:\/\//.test(url);
};

export const extractFileInfo = (url) => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
    const lastDotIndex = filename.lastIndexOf('.');

    if (lastDotIndex === -1) return null;

    return {
      name: filename.substring(0, lastDotIndex),
      extension: filename.substring(lastDotIndex + 1),
      basePath: url.substring(0, url.lastIndexOf('/')),
      queryParams: urlObj.search,
    };
  } catch {
    return null;
  }
};

export const generateSrcSet = (url, sizes = IMAGE_SIZES, maxSizeIndex = 0, availableSizes = null) => {
  if (!isOptimizableUrl(url)) return null;

  const fileInfo = extractFileInfo(url);
  if (!fileInfo) return null;

  const { name, basePath, queryParams } = fileInfo;

  // Filtrar tamaños disponibles si se proporcionan
  let sizesToUse = availableSizes || sizes;

  // Excluir tamaños más grandes según maxSizeIndex
  // maxSizeIndex = 0: incluir todos
  // maxSizeIndex = 1: excluir el último (más grande)
  // maxSizeIndex = 2: excluir los últimos 2, etc.
  if (maxSizeIndex > 0 && maxSizeIndex < sizesToUse.length) {
    sizesToUse = sizesToUse.slice(0, sizesToUse.length - maxSizeIndex);
  }

  const srcSetEntries = sizesToUse.map((size) => {
    const optimizedFilename = `${name}_file_${size}.${OPTIMIZED_FORMAT}`;
    const optimizedUrl = `${basePath}/${optimizedFilename}${queryParams}`;
    return `${optimizedUrl} ${size}w`;
  });

  return srcSetEntries.join(', ');
};

export const generateSizes = (breakpoints = null) => {
  const defaultSizes = ['(max-width: 640px) 100vw', '(max-width: 768px) 80vw', '(max-width: 1024px) 60vw', '50vw'];

  return breakpoints ? breakpoints.join(', ') : defaultSizes.join(', ');
};

export const createFallbackHandler = (originalSrc, onError) => {
  let fallbackAttempted = false;

  return (event) => {
    if (!fallbackAttempted && event.target) {
      fallbackAttempted = true;

      // Eliminar srcSet para que navegador no reintente variantes
      event.target.removeAttribute('srcset');
      event.target.removeAttribute('sizes');

      // Volver a imagen original
      event.target.src = originalSrc;

      // Llamar handler personalizado si existe
      if (onError) {
        onError(event);
      }
    }
  };
};
